import { useEffect } from 'react';

import { useAuthStore } from '@/stores/authStore';

/**
 * Hook to initialize and manage auth state
 */
export function useAuth() {
  const {
    checkAuthStatus,
    isLoading,
    isAuthenticated,
    isAdmin,
    user,
    error,
    login,
    confirmMfa,
    logout,
    mfaRequired,
    mfaEnabled,
    fetchMfaStatus,
  } = useAuthStore();

  useEffect(() => {
    checkAuthStatus();
  }, [checkAuthStatus]);

  return {
    isLoading,
    isAuthenticated,
    isAdmin,
    user,
    error,
    login,
    confirmMfa,
    logout,
    mfaRequired,
    mfaEnabled,
    fetchMfaStatus,
  };
}
